import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        employabilityFormIsOpen: true,
        opinionFormIsOpen: false,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [],
        formActions: [
            {
                btn_text: '<i class="far fa-save"></i> Negatív sablon mentése',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'saveNegativeTemplate'
            },
            {
                btn_text: '<i class="fas fa-upload"></i> Negatív sablon betöltése',
                event_name: "customClick",
                class: "btn btn-info mx-1",
                event_payload: 'getNegativeTemplate'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            },
            {
                btn_text: '<i class="fas fa-print"></i> Mentés és nyomtatás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class mx-1",
                event_payload: 'saveAndPrint'
            }
        ],
        rowActionsReadOnly: [
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'printRow'
            },
        ],
        rowActions: [
            {
                btn_text: 'Validálás',
                title: 'Validálás',
                event_name: "customClick",
                class: "btn btn-outline-teal",
                event_payload: 'showValidatePopup',
                additionalButtonVisible: "isDocumentValidated",
            },
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'printRow'
            },
            {
                btn_text: '<i class="fas fa-history"></i>',
                title: 'Előzmények',
                event_name: "customClick",
                class: "btn btn-outline-purple",
                event_payload: 'showHistory'
            },
            {
                btn_text: '<i class="far fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'edit',
                additionalButtonVisible: "isDocumentValidated",
            },
            {
                btn_text: '<i class="fas fa-unlock"></i>',
                title: 'Felnyitás',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'seeEdit',
                additionalButtonVisible: "isDocumentValidatedReopen",
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
                additionalButtonVisible: "isDocumentValidated",
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow',
            }
        ],
        headerFields: [
            {
                name: "treatment.startDate",
                label: "Kezelés időpontja",
                slot_name: "startDate_format",
                visibility: true
            },
            {
                name: "siteGroup.name",
                label: "Munkakör",
                visibility: true
            },
            {
                name: "employabilityType.text",
                label: "Munkaalkalmassági vélemény típusa",
                visibility: true
            },
            {
                name: "employabilityTypeId",
                label: "Munkaalkalmassági vélemény típusa",
                visibility: false,
                formVisible: true,
                formSize: 4,
                formType: "select",
                formRequired: true,
                selectOptions: {
                    apiCallback: Api.getEmployabilityTypes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "rowBreak1",
                label: "rowBreak",
                rowBreak: true,
                formSize: 8,
                visibility: false,
                formVisible: true
            },
            {
                name: "complaints",
                label: "Panaszok",
                visibility: false,
                formVisible: true,
                formSize: 4,
                formType: "textarea"
            },
            {
                name: "rowBreak2",
                label: "rowBreak",
                rowBreak: true,
                formSize: 8,
                visibility: false,
                formVisible: true
            },
            {
                name: "bodyWeight",
                label: "Testsúly (kg)",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "number"
            },
            {
                name: "height",
                label: "Testmagasság (m)",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "number",
                numberStep: 0.01,
                viewModalShow: true
            },
            {
                name: "bodyMassIndex",
                label: "Testtömegindex",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "number",
                formReadOnly: true,
                viewModalShow: true
            },
            {
                name: "rowBreak3",
                label: "rowBreak",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "skinAndVisibleMucosa",
                label: "Bőr és látható nyálkahártyák",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "thyroid",
                label: "Mirigyek (pajzsmirigy)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "bonesAndJoints",
                label: "Csontok és ízületek",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "flatfoot",
                label: "Lúdtalp",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "mouthNoseAndPharynxFormulas",
                label: "Száj-, orr- és garatképletek",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "toothCondition",
                label: "Fogazat",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "lungs",
                label: "Tüdő",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "heart",
                label: "Szív",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "bloodPressureMin",
                label: "Vérnyomás /min",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "number"
            },
            {
                name: "bloodPressureHgmm",
                label: "Vérnyomás Hgmm",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "number"
            },
            {
                name: "rowBreak4",
                label: "rowBreak",
                rowBreak: true,
                formSize: 8,
                visibility: false,
                formVisible: true
            },
            {
                name: "vascularSystem",
                label: "Érrendszer (variocositas, nodus)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "gastric",
                label: "Has",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "nervousSystem",
                label: "Idegrendszer",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "rowBreak6",
                label: "rowBreak",
                rowBreak: true,
                formSize: 3,
                visibility: false,
                formVisible: true
            },
            {
                name: "hearingRight",
                label: "Hallás (jobb)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "hearingLeft",
                label: "Hallás (bal)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "rowBreak7",
                label: "rowBreak",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "seeingRight",
                label: "Látás (jobb)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "seeingLeft",
                label: "Látás (bal)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "colorSeeing",
                label: "Színlátás",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "rowBreak8",
                label: "rowBreak",
                rowBreak: true,
                formSize: 3,
                visibility: false,
                formVisible: true
            },
            {
                name: "resultsOfAdditionalTests",
                label: "Kiegészítő szakvizsgálatok eredményei",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "textarea"
            },
            {
                name: "restrictionText",
                label: "Munkaalkalmasság, korlátozások, feltételek",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "textarea"
            },
            {
                name: "capableStatusId",
                label: "Alkalmasság",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getCapableStatus,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "capableStatus.text",
                label: "Alkalmasság",
                visibility: true,
                formVisible: false
            },
            {
                name: "validityDef",
                label: "Érvényesség",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "select",
                selectOptions: {
                    externalOptionList: [
                        {id: 1, text: '1 hónap'},
                        {id: 3, text: '3 hónap'},
                        {id: 6, text: '6 hónap'},
                        {id: 12, text: '12 hónap'},
                        {id: 24, text: '24 hónap'},
                        {id: -1, text: 'Egyéb'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "validity",
                label: "Érvényesség",
                visibility: true,
                slot_name: "date_format",
                sort: true,
                formVisible: true,
                formSize: 2,
                formType: "date",
                formRequired: true
            },
            {
                name: "createdBy",
                label: "Létrehozó",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Létrehozás időpontja",
                slot_name: "created_on_format",
                visibility: true
            },
            {
                name: "validated",
                label: "Státusz",
                visibility: true,
                slot_name: "validated_format",
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
